module.exports = __webpack_public_path__ + "ci_vendor_jennifer4.72c40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_jennifer4.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_jennifer4.svg
// module chunks = main